import PropTypes from "prop-types";
import { WineClubs } from "vino/components";

const Block = ({ attributes }) => {
	return <WineClubs attributes={attributes} />;
};

Block.propTypes = {
	attributes: PropTypes.object,
};

export default Block;
